let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eildr")).then(() => parcelRequire('8OcF1'));